module.exports = __webpack_public_path__ + "static/media/bfile-motorcycle.287fb09b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-motorcycle.svg
// module id = 553
// module chunks = 0